export default {
  isLoading: false,
  featureToggle: {
    productTour: process.env.VUE_APP_FEATURE_TOGGLE_TOUR
  },
  loggedIn: false,
  loggedInLoading: true,
  popupDeleteProject: false,
  popupTooManyProjects: false,
  popupExportProjectData: false,
  selectedPriceRange: "mid",
  tokenData: {},
  popupProject: "",
  projectTemplates: [],
  popupOn: false,
  authError: null,
  afterEmailRecovery: null,
  uid: null,
  email: null,
  fullName: null,
  emailVerified: true,
  verificationKey: null,
  company: null,
  phone: null,
  address: null,
  city: null,
  country: null,
  province: null,
  postalCode: null,
  profileImage: null,
  companyName: null,
  companyWebsite: null,
  companyType: null,
  companyRate: null,
  companyContingency: null,
  companyCost: null,
  companyPlan: "free",
  companyImage: null,
  companyPhone: null,
  companyAddress: null,
  companyCity: null,
  companyCountry: null,
  companyProvince: null,
  companyPostalCode: null,
  newsArticles: null,
  loading: true,
  myProjects: {},
  myProjectDetails: {},
  myProjectDetailsFull: {},
  currentProjectName: "",
  currentProjectRate: 0,
  currentProjectCost: 0,
  currentProjectModules: 0,
  currentProjectModuleColumns: 0,
  currentProjectContingency: 0,
  currentProjectOverrides: [],
  currentProjectPhases: [],
  currentProjectComments: [],
  showPricesComments: false,
  showCalculator: false,
  showPricesPrices: false,
  showPricesHours: false,
  companyTasks: [],
  billingID: "",
  myCompany: null,
  myProjectList: [],
  selectedCell: {},
  editingCell: {},
  backupPosition: 0,
  undoCount: 0,
  fromUndo: false,
  currentProjectFull: null,
  projectBackup: [],
  userRole: 'admin',
  redirectUrl: ''
};
